// react-native-device-info stand-in. The unique id is generated once per
// browser and kept in localStorage; it is an install identifier, not a
// secret, and the phone's equivalent is likewise stable per install.

import { APP_VERSION, BUILD_NUMBER } from './webVersion';

const UNIQUE_ID_KEY = 'fk.device.id';

function readOrCreateUniqueId(): string {
  try {
    const existing = window.localStorage.getItem(UNIQUE_ID_KEY);
    if (existing) return existing;
    const fresh =
      typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : Array.from(crypto.getRandomValues(new Uint8Array(16)))
            .map((b) => b.toString(16).padStart(2, '0'))
            .join('');
    window.localStorage.setItem(UNIQUE_ID_KEY, fresh);
    return fresh;
  } catch {
    return 'web-unknown';
  }
}

function browserName(): string {
  const ua = navigator.userAgent;
  if (/Edg\//.test(ua)) return 'Edge';
  if (/OPR\//.test(ua)) return 'Opera';
  if (/Chrome\//.test(ua)) return 'Chrome';
  if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) return 'Safari';
  if (/Firefox\//.test(ua)) return 'Firefox';
  return 'Browser';
}

function osName(): string {
  const ua = navigator.userAgent;
  if (/Windows/.test(ua)) return 'Windows';
  if (/Mac OS X/.test(ua)) return 'macOS';
  if (/Android/.test(ua)) return 'Android';
  if (/iPhone|iPad/.test(ua)) return 'iOS';
  if (/Linux/.test(ua)) return 'Linux';
  return 'Web';
}

export function getVersion(): string {
  return APP_VERSION;
}
export function getBuildNumber(): string {
  return BUILD_NUMBER;
}
export function getReadableVersion(): string {
  return `${APP_VERSION}.${BUILD_NUMBER}`;
}
export function getBundleId(): string {
  return 'com.myfinalkey.web';
}
export function getApplicationName(): string {
  return 'MyFinalKey';
}
export async function getUniqueId(): Promise<string> {
  return readOrCreateUniqueId();
}
export function getUniqueIdSync(): string {
  return readOrCreateUniqueId();
}
export function getDeviceId(): string {
  return `web-${browserName().toLowerCase()}`;
}
export function getModel(): string {
  return browserName();
}
export async function getDeviceName(): Promise<string> {
  return `${browserName()} on ${osName()}`;
}
export function getSystemName(): string {
  return osName();
}
export function getSystemVersion(): string {
  return 'web';
}
export function getBrand(): string {
  return browserName();
}
export async function isEmulator(): Promise<boolean> {
  return false;
}
export async function isTablet(): Promise<boolean> {
  return false;
}

export default {
  getVersion,
  getBuildNumber,
  getReadableVersion,
  getBundleId,
  getApplicationName,
  getUniqueId,
  getUniqueIdSync,
  getDeviceId,
  getModel,
  getDeviceName,
  getSystemName,
  getSystemVersion,
  getBrand,
  isEmulator,
  isTablet,
};
